module.exports = __webpack_public_path__ + "media/building.fbf0982b.mp4";